(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wm-cart-enhancements"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wm-cart-enhancements')) {
    customElements.define('wm-cart-enhancements', class extends HTMLElement {
      connectedCallback() {
        const count = this.dataset.itemCount;
        document.querySelectorAll('.wm-header__cart-count').forEach(element => {
          element.textContent = count;
          element.style.display = Number(count) > 0 ? '' : 'none';
        });
        document.querySelectorAll('.wm-header__cart-price, .wm-header__mobile-cart-price').forEach(element => {
          element.textContent = this.dataset.total;
        });
        document.querySelectorAll('.wm-header__cart').forEach(element => {
          element.setAttribute('aria-label', this.dataset.cartLabel);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wm-coin-filter-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wm-coin-filter-search')) {
    customElements.define('wm-coin-filter-search', class extends HTMLElement {
      connectedCallback() {
        this.group = this.closest('[data-filter-group]');
        this.input = this.querySelector('[data-wm-coin-search-input]');
        this.clearButton = this.querySelector('[data-wm-coin-search-clear]');
        this.emptyMessage = this.querySelector('[data-wm-coin-search-empty]');
        if (!this.group || !this.input) return;

        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.input.addEventListener('input', () => this.updateResults(), options);
        this.input.addEventListener('keydown', event => {
          if (event.key === 'Enter') event.preventDefault();
        }, options);
        this.clearButton.addEventListener('click', () => {
          this.input.value = '';
          this.updateResults();
          this.input.focus();
        }, options);

        this.observer = new MutationObserver(records => {
          const listChanged = records.some(record => [...record.addedNodes].some(node =>
            node.nodeType === 1 && (
              node.matches('.filter-form__list-wrapper, [data-filter-list-item]') ||
              node.querySelector('[data-filter-list-item]')
            )
          ));
          if (listChanged) this.updateResults();
        });
        this.observer.observe(this.group, { childList: true, subtree: true });
        this.updateResults();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }

      updateResults() {
        const query = this.input.value.trim().toLocaleLowerCase();
        const words = query.split(/\s+/).filter(Boolean);
        const items = this.group.querySelectorAll('[data-filter-list-item]');
        let matches = 0;
        items.forEach(item => {
          const label = (item.dataset.itemLabel || '').toLocaleLowerCase();
          const matchesQuery = words.every(word => label.includes(word));
          item.dataset.filterItemSearchMatch = String(matchesQuery);
          if (matchesQuery) matches += 1;
        });
        this.group.dataset.filterSearchActive = String(words.length > 0);
        this.group.dataset.filterSearchEmpty = String(words.length > 0 && matches === 0);
        this.clearButton.hidden = this.input.value.length === 0;
        this.emptyMessage.hidden = words.length === 0 || matches > 0;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wm-coin-finder-enhancements"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wm-coin-finder-enhancements')) {
    customElements.define('wm-coin-finder-enhancements', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.initialize(), {
            once: true,
            signal: this.controller.signal
          });
        } else {
          this.initialize();
        }
      }

      disconnectedCallback() {
        this.controller.abort();
      }

      initialize() {
        const finder = document.getElementById('wmCoinFinder');
        const coin = document.getElementById('wmWizardCoin');
        const form = document.getElementById('wmKnownCoinWizard');
        if (!finder || !coin || !form || coin.options.length < 2 || finder.classList.contains('wm-finder-ready')) return;

        const normalize = value => value.toLowerCase().normalize('NFKD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/u\.s\.?/g, 'us')
          .replace(/⁄/g, '/')
          .replace(/[^a-z0-9$/.]+/g, ' ')
          .trim();
        const placeholder = coin.options[0].cloneNode(true);
        const groups = Array.from(coin.querySelectorAll('optgroup')).map(group => ({
          element: group.cloneNode(false),
          options: Array.from(group.children).map(option => ({
            element: option.cloneNode(true),
            search: normalize(option.textContent + ' ' + option.value + ' ' + group.label)
          }))
        }));
        const search = this.querySelector('[data-search]').content.firstElementChild.cloneNode(true);
        const input = search.querySelector('input');
        const clear = search.querySelector('button');
        const status = search.querySelector('[role="status"]');
        coin.before(search);
        const intro = this.querySelector('[data-mobile-intro]').content.cloneNode(true);
        const help = this.querySelector('[data-mobile-help]').content.cloneNode(true);
        form.before(intro, help);
        finder.classList.add('wm-finder-ready');

        const filterCoins = () => {
          const terms = normalize(input.value).split(/\s+/).filter(Boolean);
          const previous = coin.value;
          const fragment = document.createDocumentFragment();
          fragment.append(placeholder.cloneNode(true));
          let count = 0;
          let keepSelected = false;
          groups.forEach(group => {
            const element = group.element.cloneNode(false);
            group.options.forEach(option => {
              if (!terms.every(term => option.search.includes(term))) return;
              element.append(option.element.cloneNode(true));
              count += 1;
              if (option.element.value === previous) keepSelected = true;
            });
            if (element.children.length) fragment.append(element);
          });
          coin.replaceChildren(fragment);
          coin.value = keepSelected ? previous : '';
          coin.disabled = count === 0;
          clear.hidden = input.value.length === 0;
          status.hidden = terms.length === 0;
          status.textContent = count === 0 ? this.dataset.noMatches : count === 1
            ? this.dataset.oneMatch : this.dataset.manyMatches.replace('[count]', String(count));
          if (coin.value !== previous) coin.dispatchEvent(new Event('change', { bubbles: true }));
        };

        const options = { signal: this.controller.signal };
        const syncSubmitState = () => {
          const submit = form.querySelector('#wmWizardSubmit');
          if (!submit) return;
          const disabled = Array.from(form.querySelectorAll('select[required]'))
            .some(select => !select.value || select.disabled);
          submit.disabled = disabled;
          submit.setAttribute('aria-disabled', String(disabled));
        };
        form.addEventListener('change', syncSubmitState, options);
        window.addEventListener('pageshow', syncSubmitState, options);
        syncSubmitState();
        let settingChoices;
        let finding = false;
        const loadSettings = () => {
          if (!settingChoices) {
            settingChoices = fetch(this.dataset.pendantUrl, { credentials: 'same-origin' })
              .then(response => {
                if (!response.ok) throw new Error('Unable to load mounting settings');
                return response.text();
              })
              .then(html => {
                const document = new DOMParser().parseFromString(html, 'text/html');
                const select = document.querySelector('#WmStableSetting');
                if (!select) throw new Error('Mounting settings are unavailable');
                return {
                  param: select.dataset.filterName,
                  values: Array.from(select.options).map(option => ({
                    label: normalize(option.textContent.replace(/\s*\([\d,]+\)\s*$/, '')),
                    value: option.value
                  }))
                };
              })
              .catch(error => { settingChoices = null; throw error; });
          }
          return settingChoices;
        };
        form.addEventListener('submit', async event => {
          const mounting = form.querySelector('#wmWizardMounting');
          const metal = form.querySelector('#wmWizardMetal');
          if (mounting.value === 'ring') return;
          event.preventDefault();
          event.stopImmediatePropagation();
          if (finding) return;
          syncSubmitState();
          if (!coin.value || !mounting.value || !metal.value || coin.disabled) return;
          const coinType = coin.selectedOptions[0].getAttribute('data-pendant');
          if (!coinType) return;
          const selection = [coin.value, mounting.value, metal.value].join('|');
          const submit = form.querySelector('#wmWizardSubmit');
          const originalLabel = submit.textContent;
          finding = true;
          submit.textContent = this.dataset.loading;
          submit.setAttribute('aria-busy', 'true');
          try {
            const settings = await loadSettings();
            if (selection !== [coin.value, mounting.value, metal.value].join('|')) return;
            const wanted = mounting.value === 'prong' ? 'prong' : 'screw top';
            const setting = settings.values.find(value => value.label === wanted);
            if (!setting || !setting.value || !settings.param) throw new Error('Mounting setting not found');
            const destination = new URL(this.dataset.pendantUrl, window.location.origin);
            destination.searchParams.set('sort_by', 'manual');
            destination.searchParams.set('filter.p.m.Coin.Type', coinType);
            destination.searchParams.set(settings.param, setting.value);
            destination.searchParams.set('filter.p.m.Metal.type', metal.value);
            const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
            if (preview) destination.searchParams.set('preview_theme_id', preview);
            destination.hash = 'wm-matching-mountings';
            window.location.assign(destination.toString());
          } catch (error) {
            status.hidden = false;
            status.textContent = this.dataset.resultError;
          } finally {
            finding = false;
            submit.textContent = originalLabel;
            submit.removeAttribute('aria-busy');
            syncSubmitState();
          }
        }, { ...options, capture: true });
        input.addEventListener('input', filterCoins, options);
        input.addEventListener('search', filterCoins, options);
        input.addEventListener('keydown', event => {
          if (event.key === 'Enter') {
            event.preventDefault();
            if (!coin.disabled) coin.focus();
          }
        }, options);
        clear.addEventListener('click', () => {
          input.value = '';
          filterCoins();
          input.focus();
        }, options);
        form.addEventListener('reset', () => {
          queueMicrotask(() => {
            input.value = '';
            filterCoins();
            coin.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }, options);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wm-coin-mounting-guide-stable"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.wm-stable-guide__form').forEach(function(form) {
    form.addEventListener('change', function(event) {
      event.stopPropagation();
    });

    form.addEventListener('submit', function(event) {
      event.preventDefault();
      event.stopPropagation();

      var destination = new URL(form.action, window.location.origin);

      form.querySelectorAll('[data-filter-name]').forEach(function(select) {
        if (select.value) {
          destination.searchParams.append(select.dataset.filterName, select.value);
        }
      });

      var currentUrl = new URL(window.location.href);
      if (currentUrl.searchParams.has('preview_theme_id')) {
        destination.searchParams.set('preview_theme_id', currentUrl.searchParams.get('preview_theme_id'));
      }

      destination.hash = 'wm-matching-mountings';
      window.location.assign(destination.toString());
    });
  });

  (function() {
    var interrupted = false;

    function alignMatchingMountings() {
      var results = document.getElementById('wm-matching-mountings');
      if (interrupted || !results || window.location.hash !== '#wm-matching-mountings') return;

      var header = document.querySelector('.wm-header');
      var offset = header ? Math.max(0, header.getBoundingClientRect().bottom) + 12 : 12;
      results.style.scrollMarginTop = offset + 'px';
      results.scrollIntoView({ block: 'start', behavior: 'instant' });
    }

    function stopAligning() {
      interrupted = true;
    }

    window.addEventListener('wheel', stopAligning, { passive: true, once: true });
    window.addEventListener('touchstart', stopAligning, { passive: true, once: true });
    window.addEventListener('keydown', stopAligning, { once: true });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', alignMatchingMountings, { once: true });
    } else {
      alignMatchingMountings();
    }

    window.addEventListener('load', alignMatchingMountings, { once: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wm-product-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wm-product-video-gallery')) {
    customElements.define('wm-product-video-gallery', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true, signal: this.abort.signal });
        } else {
          this.initialize();
        }
      }

      disconnectedCallback() {
        this.abort.abort();
        cancelAnimationFrame(this.frame);
        this.stop();
      }

      initialize() {
        this.root = this.closest('[data-section-type="product"]');
        if (!this.root) return;
        this.videos = [...this.root.querySelectorAll('[data-supplier-video]')];
        this.mobile = this.root.querySelector('.product__media-container.below-mobile');
        this.slider = this.mobile.querySelector('.scroll-slider__slider');
        this.mobileSlide = this.mobile.querySelector('[data-supplier-video]').closest('[data-slide-index]');
        this.mediaId = this.mobileSlide.dataset.mediaItemId;
        this.eventPrefix = `scroll-slider-${this.root.dataset.scrollerId}`;
        const options = { signal: this.abort.signal };
        this.root.addEventListener('click', event => this.onClick(event), { ...options, capture: true });
        document.addEventListener(`${this.eventPrefix}:slide-changed`, event => this.onSlide(event), options);
        document.addEventListener('product:variant-change', () => this.stop(), options);
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.stop(); }, options);
        this.breakpoint = window.matchMedia('(min-width: 960px)');
        this.breakpoint.addEventListener('change', () => this.stop(), options);
      }

      stop() {
        this.requested = false;
        cancelAnimationFrame(this.frame);
        this.videos?.forEach(video => {
          video.pause();
          if (video.readyState > 0) video.currentTime = 0;
        });
      }

      play(video) {
        if (!this.isConnected || !this.requested) return;
        this.videos.forEach(other => { if (other !== video) other.pause(); });
        if (!video.getAttribute('src')) video.src = video.dataset.videoUrl;
        const attempt = video.play();
        if (attempt) attempt.catch(() => {});
      }

      onClick(event) {
        const thumbnail = event.target.closest('[data-product-thumbnail]');
        if (!thumbnail) return;
        if (!thumbnail.hasAttribute('data-supplier-video-thumbnail')) {
          this.stop();
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        this.requested = true;
        this.root.querySelectorAll('video').forEach(video => { if (!video.hasAttribute('data-supplier-video')) video.pause(); });
        this.root.querySelectorAll('[data-product-thumbnail]').forEach(button => {
          button.classList.toggle('active', button.dataset.thumbnailId === this.mediaId);
        });
        const desktop = this.root.querySelector('.product__media-container.above-mobile');
        desktop.querySelectorAll('[data-product-media-wrapper]').forEach(media => {
          media.classList.toggle('hidden', media.dataset.mediaItemId !== this.mediaId);
        });
        if (this.mobile.getClientRects().length) {
          const alreadySelected = Math.abs(this.slider.scrollLeft - this.mobileSlide.offsetLeft) < 2;
          document.dispatchEvent(new CustomEvent(`${this.eventPrefix}:go-to-slide`, {
            detail: { slideIndex: this.mobileSlide.dataset.slideIndex, behavior: 'instant' }
          }));
          if (alreadySelected) this.play(this.mobileSlide.querySelector('video'));
        } else {
          this.play(desktop.querySelector('[data-supplier-video]'));
        }
      }

      onSlide(event) {
        if (!this.mobile.getClientRects().length) return;
        const selected = event.detail.currentElement;
        cancelAnimationFrame(this.frame);
        if (selected !== this.mobileSlide) {
          this.stop();
          return;
        }
        const video = selected.querySelector('[data-supplier-video]');
        if (!video.getAttribute('src')) video.src = video.dataset.videoUrl;
        if (this.requested) this.frame = requestAnimationFrame(() => this.play(video));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
